module.exports = __webpack_public_path__ + "static/pfmall-14b582630e6ed2afaef9ab2359398204.jpeg";